import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { FeatureFlag, RouteName, TextKey } from '@mews-commander/enums';
import { SellLimits } from '@mews-commander/modules/src/modules/sellLimits';
import { DialogProvider } from '@mews-commander/ui';
import { MewsTeam, RouteType } from '@mews/enums';

const SellLimitsComponent = () => {
    const { currentEnterpriseId } = Route.useParams();
    const { OwnerId } = Route.useSearch();

    return (
        <DialogProvider>
            <SellLimits enterpriseId={currentEnterpriseId} serviceId={OwnerId} />
        </DialogProvider>
    );
};

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/SellLimits/Index/')({
    validateSearch: z.object({
        OwnerId: z.string().uuid(),
    }),
    beforeLoad: ({ context: { checkFeatureFlag, checkPrivilege } }) => {
        checkFeatureFlag(FeatureFlag.sellLimitsEnabled);
        checkPrivilege('manageSellLimits');
    },
    component: SellLimitsComponent,
    staticData: {
        title: TextKey.SellLimits,
        routeName: RouteName.SellLimits,
        owner: MewsTeam.RevenueServices,
        type: RouteType.Frontend,
    },
});
